import clickOutside from "../directives/click-ouside.js";
import fileDropzone from "../directives/file-dropzone.js";
import { installLoadMoreSelects } from "../directives/load-more-select";

/**
 * You can register global directives here and use them as a plugin in your main Vue instance
 */

const GlobalDirectives = {
  install(Vue) {
    Vue.directive("click-outside", clickOutside);
    Vue.directive("file-dropzone", fileDropzone);
    installLoadMoreSelects(Vue);
  }
};

export default GlobalDirectives;
